import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import ConditionalWidthTableCell from '../../../../core/components/table/ConditionalWidthTableCell';
import getAreAdditionalChargesApplicableForProduct from '../../../util/getAreAdditionalChargesApplicableForProduct';
import usePriceFormatter from '../../../../core/hooks/usePriceFormatter';
import { TableCellTextWithSubtext } from '../../../../core/components/table/TableCellText';
import type { ProductItem } from '../../../types';
import type { ProductVariantsTableProductRowProps } from './types';
import ProductRowCustomerPriceColumn from './ProductRowCustomerPriceColumn';

const RetailPriceCell = memo(
    ({ retailPrice = 0 }: { retailPrice?: number }) => {
        const priceFormatter = usePriceFormatter();

        const formattedRetailPrice = priceFormatter(retailPrice);
        return (
            <TableCellTextWithSubtext
                text={
                    <span>
                        <FormattedMessage id={formattedRetailPrice.currency} />
                        &nbsp;
                        {formattedRetailPrice.price}
                    </span>
                }
                subText={<FormattedMessage id="VAT included" />}
            />
        );
    }
);

const PriceColumns = memo(
    ({
        customerPrice,
        showDiscountColumn,
        fixedWidth,
        product,
        variant,
    }: Pick<
        ProductVariantsTableProductRowProps,
        | 'customerPrice'
        | 'showDiscountColumn'
        | 'fixedWidth'
        | 'product'
        | 'variant'
    >) => {
        return (
            <>
                <ConditionalWidthTableCell
                    fixedWidth={fixedWidth}
                    width="110px"
                >
                    <RetailPriceCell retailPrice={customerPrice?.retailPrice} />
                </ConditionalWidthTableCell>
                <ProductRowCustomerPriceColumn
                    fixedWidth={fixedWidth}
                    customerPrice={customerPrice}
                    showDiscountColumn={showDiscountColumn}
                    areAdditionalChargesApplicable={getAreAdditionalChargesApplicableForProduct(
                        product
                    )}
                    product={variant || (product as ProductItem)}
                    onSale={product.onSale}
                    showInlineDiscount={product.onSale}
                />
            </>
        );
    }
);

export default PriceColumns;
